import dayjs from "dayjs";
import { holidayChecks } from "@src/util/holidayChecks";
import isoWeek from "dayjs/plugin/isoWeek";
import { useDispatch } from "react-redux";
import Spinner from "@src/components/spinner";
import { CancelDutyModal } from "../../cancelDuty/cancelDuty.modal";
import { useEffect, useRef, useState } from "react";
import { CaretDownFilled, UserOutlined } from "@ant-design/icons";
import { useApolloClient, useLazyQuery, useMutation, useQuery } from "@apollo/client";
import { Alert, Avatar, DatePicker, Dropdown, Input, Menu, Modal, Popover, Popconfirm, Select, Divider, Tag, Form } from "antd";
import Swal from "sweetalert2";
import { GetEmployeeRecord } from "@src/util/query/employee.query";
import { getPayLevelQuery } from "@src/util/query/paylevel.query";
import { shiftTypeQuery } from "@src/util/query/shiftType.query";
import { SHOW_HOUR_TYPE, defaultHourTypeId } from "@src/util/hourType";
import { newScheduleTimesMutation } from "@src/util/mutation/scheduleTimes.mutation";
import { setNotification } from '@src/middleware/redux/reducers/notification.reducer';
import { updateScheduleMutation } from "@src/util/mutation/schedule.mutation";
import { getScheduledJobById } from "@src/util/query/schedule.query";
import { UpdateScheduleByField } from "@src/util/mutation/schedule.mutation";
import { CheckEmployeeDuplicateQuery, EmployeeObjectQuery, getEmployeeForScheduleSearchQuery } from "@src/util/query/employee.query";
import { AddEmployeeMutation, RestoreEmployeeMutation } from "@src/util/mutation/employee.mutation";
import { CheckFailureModal } from "../../checkFail.model";
import { newScheduleCheckMutation } from "@src/util/mutation/scheduleChecks.mutation";
import { dutyTypesForSite, isDirectMobileDriver, scheduleCheckFailureList } from "@src/util/scheduleCheckFailureList";
import { deleteScheduleByScheduleIdMutation } from "@src/util/mutation/schedule.mutation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faPlus, faSearch, faTimes } from "@fortawesome/free-solid-svg-icons";
import { getSystemHolidayQuery } from "@src/util/query/systemHoliday.query";
import { calculatePayBillMutation } from "@src/util/mutation/calculatePayBill.mutation";
import { getPayBillByScheduleIdQuery } from "@src/util/query/paybill.query";
import { getAgencies } from "@src/util/query/agency.query";
import { updateScheduleTimesMutation } from "@src/util/mutation/scheduleTimes.mutation";
import { useSelector } from "react-redux";
import { convertToLocalTime } from "@src/util/timezone/timezoneAdjustment";
import { CheckGmtBst } from "@src/util/timezone/checkGmtBst";
import { FormDrawer } from "../../../formDrawer";
import { objectType } from "@src/util/types/object.types";

const timezone = "Europe/London";

dayjs.extend(isoWeek);

// dayjs.locale('en-gb');

export const EditDutyTimes = ({scheduleId, close, isCompleted, isOnDuty})=>{
    


    const {authenticatedUserDetail} = useSelector(state=>state.userAuthReducer);   
    const [getEmployeeOnSearch, {data: empSearchData, loading: empSearchDataLoading} ]= useLazyQuery(getEmployeeForScheduleSearchQuery);



    const {data: scheduledJobData, refetch: scheduleJobRefetch, loading: scheduledJobLoading} = useQuery(getScheduledJobById,{
        variables: {
            jobId: scheduleId
        },
        fetchPolicy: 'network-only',
        skip: !scheduleId
    });

    // duty type and hour type
    const {data: dutyTypeData, loading: dutyTypeLoading, refetchDutyType} = useQuery(getPayLevelQuery,{
        fetchPolicy: 'network-only',
    });
    const {data: hourTypeData, loading: hourTypeDataLoading, refetch: refetchHourType} = useQuery(shiftTypeQuery);

    const [newScheduleOperationTime, {loading: newScheduleLoading}] = useMutation(newScheduleTimesMutation);
    const [updateSchedule, {loading:updateScheduleLoading}] = useMutation(updateScheduleMutation);
    const [updateScheduleField, {loading:updateScheduleFieldLoading}] = useMutation(UpdateScheduleByField)


   



    const [operationalAssignedEmployee, setOperationalAssignedEmployee] = useState(null);
    const [operationalDutyType, setOperationalDutyType] = useState();
    const [operationalHourType, setOperationalHourType] = useState();
    const [operationalStartDateTime, setOpertionalStartDateTime] = useState();
    const [operationalEndDateTime, setOpertionalEndDateTime] = useState();


    const [scheduleData, setScheduleData] = useState({});
    useEffect(()=>{
        if(scheduledJobData?.getScheduledJobById?.response && !scheduledJobLoading){
            setScheduleData({...scheduledJobData?.getScheduledJobById?.response});
            setOperationalAssignedEmployee(null);
        }
    },[scheduledJobData?.getScheduledJobById?.response, scheduledJobLoading]);

    // Hour Type is hidden (see util/hourType), so a blank pay/bill hour type can't be picked
    // any more - saving pay/bill fills it from the duty's own (or Standard Hour)
    const hourTypeFallback = scheduleData?.hourTypeId || defaultHourTypeId(hourTypeData?.getShiftType?.response);
    
    
    useEffect(()=>{
        if(!dutyTypeLoading && !hourTypeDataLoading && !newScheduleLoading && !updateScheduleLoading && !scheduledJobLoading && !hourTypeDataLoading) {
        
            const operationTime = scheduleData?.scheduletimesDetail;
            if(scheduleData?.scheduletimesDetail){
                if(operationTime?.operationalAssignedEmployee && scheduleData?.assignedEmployee){
                    setOperationalAssignedEmployee({emp: scheduleData?.OperationalTimeDetail});
                }else if(operationTime?.operationalAssignedAgency){
                    setAssignedAgency(operationTime?.operationalAssignedAgency);
                }

                setOperationalDutyType(operationTime?.operationalDutyType);
                setOperationalHourType(operationTime?.operationalHourType);

                // convertToLocalTime(operationTime?.operationalStartDate, operationTime?.operationalStartTime, false)
                // setOpertionalStartDateTime(
                //     convertToLocalTime(operationTime?.operationalStartDate, operationTime?.operationalStartTime || scheduleData?.shiftStartTime, false)
                // );
                // setOpertionalEndDateTime(
                //     convertToLocalTime(operationTime?.operationalEndDate, operationTime?.operationalEndTime || scheduleData?.shiftEndTime, false)
                // );

                setOpertionalStartDateTime(
                    dayjs.utc(operationTime?.operationalStartDate).tz(timezone)
                );
                setOpertionalEndDateTime(
                    dayjs.utc(operationTime?.operationalEndDate).tz(timezone)
                );

            }else{
                
                if(scheduleData?.assignedEmployee){
                    setOperationalAssignedEmployee({_id:scheduleData?.assignedEmployee, emp: scheduleData?.assignedEmployeeDetail});
                }

                if(scheduleData?.assignedAgency){
                    setAssignedAgency(scheduleData?.assignedAgency);
                }
                if(scheduleData?.dutyTypeId){
                    setOperationalDutyType(scheduleData?.dutyTypeId);
                }
                if(scheduleData?.hourTypeId){
                    setOperationalHourType(scheduleData?.hourTypeId);
                }
                if(scheduleData?.firstDate){
                             
                    setOpertionalStartDateTime(
                        dayjs.utc(scheduleData?.firstDate).tz(timezone)
                    );
                            
                    // setOpertionalStartDateTime(
                    //     convertToLocalTime(scheduleData?.firstDate, scheduleData?.shiftStartTime, false)
                    // );
                }
                if(scheduleData?.secondDate){
                    setOpertionalEndDateTime(
                        dayjs.utc(scheduleData?.secondDate).tz(timezone)
                    );
                    // setOpertionalEndDateTime(
                    //     convertToLocalTime(scheduleData?.secondDate, scheduleData?.shiftEndTime, false)
                    // );
                }else{
                    
                    // setOpertionalEndDateTime(
                    //     convertToLocalTime(scheduleData?.shiftEndDateTime, scheduleData?.shiftEndTime, false)
                    // );

                    setOpertionalEndDateTime(
                        dayjs.utc(scheduleData?.shiftEndDateTime).tz(timezone)
                    );

                }

            }

            setPayDutyType(scheduleData?.payDutyTypeId);
            setPayHourType(scheduleData?.payHourTypeId);
            setPayStartDateTime(scheduleData?.payStartDateTime? dayjs.utc(scheduleData?.payStartDateTime).tz(timezone) : null);
            setPayEndDateTime(scheduleData?.payEndDateTime? dayjs.utc(scheduleData?.payEndDateTime).tz(timezone) : null);
            // setPayEndDateTime(scheduleData?.payEndDateTime? convertToLocalTime(scheduleData?.payEndDateTime, (operationTime?.operationalEndTime || scheduleData?.shiftEndTime), false) : null);

            
            setBillDutyType(scheduleData?.billDutyTypeId);
            setBillHourType(scheduleData?.billHourTypeId);
            setBillStartDateTime(scheduleData?.billStartDateTime? dayjs.utc(scheduleData?.billStartDateTime).tz(timezone) : null);
            setBillEndDateTime(scheduleData?.billEndDateTime? dayjs.utc(scheduleData?.billEndDateTime).tz(timezone) : null);


        }
    },[scheduleData , dutyTypeLoading, hourTypeDataLoading, newScheduleLoading, updateScheduleLoading, scheduledJobLoading]);
    

    const [checkFailVisible, setCheckFailVisible] = useState(false);
    const [failureChecks, setFailureChecks] = useState(null);

    const [allowedSkilledForSpecificArea, setAllowedSkillsForSpecificArea] = useState([]);
    const [optionalSkilledForSpecificArea, setOptionalSkillsForSpecificArea] = useState([]);
    
    useEffect(()=>{
        if(scheduleData?.siteSkills?.length>0){
            
            setAllowedSkillsForSpecificArea(scheduleData?.siteSkills?.filter((areaSkill)=>areaSkill?.areaId==scheduleData?.siteAreaDetail?._id && areaSkill?.status && !areaSkill?.optional)?.map((skill)=>skill?.skillId));
            setOptionalSkillsForSpecificArea(scheduleData?.siteSkills?.filter((areaSkill)=>areaSkill?.areaId==scheduleData?.siteAreaDetail?._id && areaSkill?.optional)?.map((skill)=>skill?.skillId));
        
        }
    },[scheduleData?.siteSkills, scheduleData?.siteAreaDetail]);
    
    // check employee from search if it is suitable or not for specific job
    const checkEmployeeIfSuitable = (emp)=>{
        
        const { empHolidayCheck, empPendingHoliday } = holidayChecks(emp, dayjs(scheduleData?.firstDate).local());

        // if site block or not
        let blockedSite = false;
        if(emp?.blockedSites?.length>0){
            blockedSite = emp?.blockedSites?.find((bs)=>bs?.siteId==scheduleData?.site?._id)? true: false;
        }

        // branch check
        const isBranchExist = emp?.branch?.find((b)=>(b?._id==(scheduleData?.site?.branchDetail?._id || scheduleData?.branchId)));
        const branchCheck = isBranchExist? false : true;

        //============ rest period check
       
        const restPeriodCheck = false;

        const alreadyWorking = emp?.scheduleCheck?.response?.length>0? true : false;

        
        //============ rest period check terminated
        
        //=================== duty check / experience check
        
        const trainingCheck= emp?.trainedEmployeeOnSite?.find((te)=>te?.siteId==scheduleData?.site?._id)? false: true

        //=================== duty check / experience check terminated

        //================== skill check 
        let skillCheck = allowedSkilledForSpecificArea?.length==0? false : !allowedSkilledForSpecificArea.every((areaSkill)=> emp?.employeeskills?.find((empSkill)=>empSkill?.skill==areaSkill && empSkill?.isArchive!=true));
        const optionalSkillCheck = optionalSkilledForSpecificArea?.length==0? false : !optionalSkilledForSpecificArea.some((areaSkill)=> emp?.employeeskills?.find((empSkill)=>empSkill?.skill==areaSkill && empSkill?.isArchive!=true));
        if(optionalSkillCheck){
            skillCheck = true;
        }
        //================== skill check terminated
        
        //======================= visa expiry check
        const visaExpiryCheck = emp?.metadata?.requirevisa=="Yes"? 
        emp?.metadata?.visaexpirydate? 
        dayjs(emp?.metadata?.visaexpirydate, "YYYY/MM/DD").isAfter(dayjs())? false: true
        : 
        // this check will be true if visa required and date is empty
        true  : false
        //======================= visa expiry check terminated

        // skill expiry check
        let skillExpiryCheck = false;
        const matchedSkill = emp?.employeeskills?.filter((empSkill)=> 
            [...allowedSkilledForSpecificArea, ...optionalSkilledForSpecificArea]?.find((skill)=>skill==empSkill?.skill) && empSkill?.isArchive!=true)?.
            filter((skill)=> skill?.fields?.find((f)=>f?.name=="expirydate"))
            .map((skill)=> {
                const isExist = skill?.fields?.find((f)=>f?.name=="expirydate");
                if(isExist){
                    return isExist.value;
                }
            });
            
        if(matchedSkill?.length>0){
            skillExpiryCheck = matchedSkill?.every((date)=> dayjs(date).local().isAfter(dayjs())) ? false : true
        }
        
        // hard check: a direct-jobs mobile driver is never put on a duty
        const directDriverCheck = isDirectMobileDriver(emp);
        if(directDriverCheck || alreadyWorking || empHolidayCheck || empPendingHoliday || blockedSite || restPeriodCheck || skillCheck || trainingCheck || skillExpiryCheck || visaExpiryCheck || branchCheck){
            setFailureChecks({directDriverCheck, alreadyWorking, empHolidayCheck, empPendingHoliday, blockedSite, restPeriodCheck, skillCheck, trainingCheck, skillExpiryCheck, visaExpiryCheck, branchCheck, employeeData: {...emp, site:scheduleData?.site?._id}});
            setCheckFailVisible(true);
            setSearch("");
            
        }else{
            setSearch("");
            setOperationalAssignedEmployee({_id:emp?._id, isSuitable: 0, isFromSearch:1,  emp})
        }
        
    };

    
    const dispatch = useDispatch();
  
    // Function to disable all dates except the two enabled ones
    const disabledDate = (current) => {
        const enabledDates = [dayjs(scheduleData?.firstDate), 
            dayjs(scheduleData?.firstDate).add('1','day'),
        ];
        return !enabledDates.some((date) => current.isSame(date, "day"));
    };

    const [newScheduleCheck, {loading:newScheduleCheckLoading}] = useMutation(newScheduleCheckMutation);
    const [updateScheduleTimes, {loading: updateScheduleTimesLoading}] = useMutation(updateScheduleTimesMutation);

    const [isUpdating, setIsUpdating] = useState(false);

    const handelScheduleOpertaionTime = async()=>{
        try{
            setIsUpdating(true);
            setIsAssigneeIntentToChange(false);
            const startDateTime = dayjs(operationalStartDateTime).format("DD/MM/YYYY HH:mm");
            const endDateTime = dayjs(operationalEndDateTime).format("DD/MM/YYYY HH:mm");
            const operationalTimeInput = {
                siteId: scheduleData?.site?._id,
                scheduleId: scheduleData?._id,
                operationalStartDate: dayjs(operationalStartDateTime, "DD/MM/YYYY HH:mm"),
                operationalStartTime:  startDateTime?.split(" ")[1],
                operationalEndDate: dayjs(operationalEndDateTime, "DD/MM/YYYY HH:mm"),
                operationalEndTime: endDateTime?.split(" ")[1],
                operationalDutyType: operationalDutyType,
                operationalHourType: operationalHourType,
                operationalAssignedEmployee: operationalAssignedEmployee?.emp?._id? operationalAssignedEmployee?.emp?._id : null,
                operationalAssignedAgency: operationalAssignedEmployee?.emp?._id? null : assignedAgency,
                isDutyCancel: scheduleData?.isDutyCancel
            };

            if(scheduleData?.scheduletimesDetail){


                await updateScheduleTimes({
                    variables:{
                        input: operationalTimeInput
                    }
                });

            }else{

                await newScheduleOperationTime({
                    variables:{
                        input: operationalTimeInput
                    }
                });

            }

            // set to unconfirm and assign employee
            await updateSchedule({
                variables:{
                    input:{
                        _id: scheduleId,
                        status: operationalAssignedEmployee?.emp?._id? "1" : assignedAgency? "3" : "0",
                        assignedEmployee: operationalAssignedEmployee?.emp?._id? operationalAssignedEmployee?.emp?._id : null,
                        assignedAgency: operationalAssignedEmployee?.emp?._id? null : assignedAgency,
                    }
                }
            }); 

            const failureIfAny = failureChecks && Object.keys(failureChecks)?.filter((check)=>failureChecks[check]===true)?.map((check)=> scheduleCheckFailureList[check]?.description);
            if(failureIfAny?.length>0 && operationalAssignedEmployee){
                await newScheduleCheck({
                    variables:{
                        input:{
                            scheduleId: scheduleId,
                            employeeId: operationalAssignedEmployee?.emp?._id,
                            check: failureIfAny,
                            date: dayjs(),
                        }
                    }
                });
            }    

            dispatch(setNotification({
                error: false,
                notificationState: true,
                message: "Operation time was updated successfully"
            }));

            const scheduleDate = scheduleData?.secondDate?
            dayjs(scheduleData?.secondDate)
            :
            dayjs(scheduleData?.date+" "+scheduleData?.shiftEndTime, "DD/MM/YYYY HH:mm");
            
            // operational start date time operation end date time 
            // if(dayjs(operationalStartDateTime).isSame(scheduleData?.firstDate) && operationalEndDateTime.isSame(scheduleDate) && scheduleData?.assignedEmployeeDetail?._id == scheduleData?.OperationalTimeDetail?._id){
                
            //     const response = calculateTimeDifference(operationalStartDateTime, operationalEndDateTime);   
            
            //     const isBillFirstDateInBankHoilday = holiday?.find((bh)=>(operationalStartDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY/MM/DD").format("DD/MM/YYYY")) ? true : false ;
            //     const isBillSecondDateInBankHoilday = holiday?.find((bh)=>(operationalEndDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY/MM/DD").format("DD/MM/YYYY")) ? true : false ;

            //     const isPayFirstDateInBankHoilday = holiday?.find((bh)=>(operationalStartDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY/MM/DD").format("DD/MM/YYYY")) ? true : false ;
            //     const isPaySecondDateInBankHoilday = holiday?.find((bh)=>(operationalEndDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY/MM/DD").format("DD/MM/YYYY")) ? true : false ;
            
            //     const payBillInput = {

            //         _id: scheduleId,
            //         payFirstDateHour: response?.firstDateHours?.toString(),
            //         isPayFirstDateInBankHoilday,
            //         paySecondDateHour: response?.secondDateHours?.toString(),
            //         isPaySecondDateInBankHoilday,
            //         payStartDateTime,
            //         payEndDateTime,
            //         payHourTypeId: operationalHourType,
            //         payDutyTypeId: operationalDutyType,

            //         billFirstDateHour: response?.firstDateHours.toString(),
            //         isBillFirstDateInBankHoilday,
            //         billSecondDateHour: response?.secondDateHours.toString(),
            //         isBillSecondDateInBankHoilday,
            //         billStartDateTime,
            //         billEndDateTime,
            //         billHourTypeId: operationalHourType,
            //         billDutyTypeId: operationalDutyType

            //     }

            //     await updatePayBill(payBillInput);

            // }else{
             
            //     const payBillInput = {

            //         _id: scheduleId,
            //         payFirstDateHour: null,
            //         isPayFirstDateInBankHoilday: null,
            //         paySecondDateHour: null,
            //         isPaySecondDateInBankHoilday: null,
            //         payStartDateTime: null,
            //         payEndDateTime: null,
            //         payHourTypeId: null,
            //         payDutyTypeId: null,

            //         billFirstDateHour: null,
            //         isBillFirstDateInBankHoilday: null,
            //         billSecondDateHour: null,
            //         isBillSecondDateInBankHoilday: null,
            //         billStartDateTime: null,
            //         billEndDateTime: null,
            //         billHourTypeId: null,
            //         billDutyTypeId: null

            //     }

            //     await updatePayBill(payBillInput);

            // }

            await scheduleJobRefetch();

        }catch(err){
            dispatch(setNotification({
                error: true,
                notificationState: true,
                message: err?.message || "An error encountered while updating the operation time"
            }));
        }finally{
            setIsUpdating(false);
        }
    }

//============================================= 
    // employee search begin here
//=============================================
    const [searchPopup, setSearchPopup] = useState(false);
    const [activeAssociatedModule, setActiveAssociateModule] = useState("employee");
    const [assignedEmployee, setAssignedEmployee] = useState();
    const [assignedAgency, setAssignedAgency] = useState(null);
    
    
    const [search, setSearch] = useState("");
    useEffect(()=>{
        if(activeAssociatedModule=="employee" && scheduleData){
            
            const startDate = dayjs(scheduleData?.firstDate).subtract(8, 'hour')
            const endDate = dayjs(scheduleData?.firstDate).add(8, 'hour')
            
            getEmployeeOnSearch({fetchPolicy: 'cache-and-network',
                variables: {
                    input: {
                        filters:  {advanceFilter: null},
                        schedule: {startDate, endDate}
                    }
                },
                skip: !startDate || !endDate,
                fetchPolicy: 'cache-and-network'
            });
        }
    },[scheduleData, activeAssociatedModule]);

    const [scheduleStartDate, setScheduleStartDate] = useState(null);
    const [scheduleEndDate, setScheduleEndDate] = useState(null);

    useEffect(()=>{
        if(scheduleData?.firstDate){
            const startDate = dayjs(scheduleData?.firstDate).subtract(8, 'hour')
            const endDate = dayjs(scheduleData?.firstDate).add(8, 'hour')
            setScheduleStartDate(startDate);
            setScheduleEndDate(endDate);
        }
    },[scheduleData]);

    
    const searchRef = useRef(null);
    const searchSegmentRef= useRef(null);
    const searchDetailSegmentRef = useRef(null);
    const associationDropdownRef = useRef(null);

    const handleClickOutside = (event) => {

        if (associationDropdownRef?.current instanceof HTMLElement && !associationDropdownRef.current.contains(event.target) &&
            !Array.from(event.target.classList).find(cls => cls.includes('ant-select-item-option-content'))
        )
        {
            setSearchPopup(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [associationDropdownRef]);

    const [assignAgencyLocally, setAssignAgencyLocally] = useState(null);
    
    // get employee based on agency
    const { data: agencyEmployee, loading: agencyEmployeeLoading } = useQuery(getEmployeeForScheduleSearchQuery,{
        variables: {
            input: {
                filters:  {advanceFilter: [[{
                    filter: "contain_exactly",
                    filterValue: [assignAgencyLocally],
                    operator: 'Agency'
                }]]},
                schedule: {startDate:scheduleStartDate, endDate:scheduleEndDate}
            }
        },
        fetchPolicy: 'network-only',
        skip: scheduleStartDate==null || scheduleEndDate==null || assignAgencyLocally?.length<1
    });
    
    
    const [EmployeeSearchResult, setEmpSearchResult] = useState([]);

    // ===== create new employee inline from the association popover =====
    const apolloClient = useApolloClient();

    const [newEmployeeModal, setNewEmployeeModal] = useState(false);
    const [newEmployeeSchema, setNewEmployeeSchema] = useState();
    const [newEmployeeData, setNewEmployeeData] = useState([]);
    const [newEmployeeBtnEnable, setNewEmployeeBtnEnable] = useState(true);
    const [newEmployeeOverlay, setNewEmployeeOverlay] = useState(true);

    const {data: newEmployeeObject, loading: newEmployeeObjectLoading, refetch: newEmployeeObjectRefetch} = useQuery(EmployeeObjectQuery,{
        fetchPolicy: 'cache-and-network',
        skip: !newEmployeeModal
    });

    useEffect(()=>{
        if(!newEmployeeObjectLoading){
            setNewEmployeeSchema(newEmployeeObject?.getEmployeeObject?.response?.filter((dataField)=>dataField.propertyDetail?.fieldType!=="agency"));
        }
    },[newEmployeeObjectLoading]);

    const [addNewEmployeeMutation, {loading: newEmployeeProcessLoading}] = useMutation(AddEmployeeMutation);
    const [restoreNewEmployeeMutation] = useMutation(RestoreEmployeeMutation);

    const newEmployeeMutation = async (employee)=>{
        try{
            const { data: duplicateCheckData } = await apolloClient.query({
                query: CheckEmployeeDuplicateQuery,
                variables: { input: { firstname: employee?.firstname, lastname: employee?.lastname, email: employee?.metadata?.email } },
                fetchPolicy: 'network-only',
            });

            const duplicate = duplicateCheckData?.checkEmployeeDuplicate?.response;

            if(duplicate?.exists){
                if(duplicate?.isArchived && duplicate?.sameTenant){
                    const confirmResult = await Swal.fire({
                        icon: 'warning',
                        title: 'Employee Already Exists',
                        html: `An archived employee record matches <b>${duplicate?.employee?.firstname} ${duplicate?.employee?.lastname}</b>${duplicate?.employee?.metadata?.email? ` (${duplicate?.employee?.metadata?.email})` : ''}. Would you like to restore it instead of creating a new one?`,
                        showCancelButton: true,
                        confirmButtonText: 'Restore',
                        cancelButtonText: 'Cancel',
                    });

                    if(confirmResult?.isConfirmed){
                        await restoreNewEmployeeMutation({variables: {employeeId: duplicate?.employee?._id}});
                        dispatch(setNotification({
                            notificationState:true,
                            message: "Employee restored successfully",
                            error: false,
                        }));
                        setNewEmployeeData([]);
                        setNewEmployeeBtnEnable(true);
                        setNewEmployeeOverlay(true);
                        setSearch(`${employee?.firstname}`);
                        setActiveAssociateModule("employee");
                        setSearchPopup(true);
                        return true;
                    }

                    return false;
                }

                dispatch(setNotification({
                    message: duplicateCheckData?.checkEmployeeDuplicate?.message,
                    error: true,
                    notificationState: true
                }));
                return false;
            }

            await addNewEmployeeMutation({variables: {input: employee}});
            dispatch(setNotification({
                notificationState:true,
                message: "Employee was added successfully",
                error: false,
            }));
            setNewEmployeeData([]);
            setNewEmployeeBtnEnable(true);
            setNewEmployeeOverlay(true);
            setSearch(`${employee?.firstname}`);
            setActiveAssociateModule("employee");
            setSearchPopup(true);

            return true;
        }
        catch(err){
            dispatch(setNotification({
                message: err?.message,
                error: true,
                notificationState: true
            }));
            return false;
        }
    };

    const handelNewEmployeeSubmit = async (isCloseAble)=>{
        const firstname = newEmployeeData?.find((d)=>(Object.keys(d)[0]=="firstname"));
        const lastname = newEmployeeData?.find((d)=>(Object.keys(d)[0]==="lastname"));
        const branch = newEmployeeData?.find((d)=>(Object.keys(d)[0]==="branch"));

        let metadata = {};
        newEmployeeData?.map(d=>{
            if(Object.keys(d)[0]!=="firstname" && Object.keys(d)[0]!=="lastname" && Object.keys(d)[0]!=="branch"){
                metadata[Object.keys(d)[0]]= Object.values(d)[0]
            }
        });
        const employee = {
            ...firstname,
            ...lastname,
            branch: [...(branch?.branch || [])],
            metadata,
        }

        const success = await newEmployeeMutation(employee);

        if(isCloseAble && success){
            setNewEmployeeModal(false);
        }
    };

    useEffect(()=>{
        if(empSearchData?.getEmployeeForScheduleSearch?.response){
            setEmpSearchResult(empSearchData?.getEmployeeForScheduleSearch?.response);
        }else{
            setEmpSearchResult([]);
        }
    },[empSearchData?.getEmployeeForScheduleSearch?.response]);

    useEffect(()=>{
        if(search?.length>0){
            setEmpSearchResult(empSearchData?.getEmployeeForScheduleSearch?.response?.filter((emp)=> emp?.firstname?.toLowerCase()?.startsWith(search?.toLowerCase()) || emp?.lastname?.toLowerCase()?.startsWith(search?.toLowerCase())  ));
            
        }else{
            setEmpSearchResult(empSearchData?.getEmployeeForScheduleSearch?.response);

        }
    }, [search]);
  

    const {data: agencyData, loading: agencyLoading} = useQuery(getAgencies,{
        fetchPolicy: 'network-only',
        variables: {
            input: {
                filters: null
            }
        },
    });

    // search assign emp duty has been terminated========================

    const [deleteSchedule, {loading:deleteScheduleLoading}] = useMutation(deleteScheduleByScheduleIdMutation)

    // pay and bill state management

    // pay state
    const [payStartDateTime, setPayStartDateTime] = useState(null);
    const [payEndDateTime, setPayEndDateTime] = useState(null);
    const [payDutyType, setPayDutyType] = useState();
    const [payHourType, setPayHourType] = useState();
    const [payEmployeeId, setPayEmployeeId] = useState();

    const [updatePay, setUpdatePay] = useState(false);
    const [updateBill, setUpdateBill] = useState(false);
    const [changePayBill, setChangePayBill] = useState(false);

    const [holiday, setHoliday] = useState([]);
    const {data: holidayData, loading: holidayLoading} = useQuery(getSystemHolidayQuery,{
        fetchPolicy: 'network-only'
    });

    
    useEffect(()=>{
        if(holidayData?.getSystemHoliday && !holidayLoading){
            setHoliday(holidayData?.getSystemHoliday?.holiday);
            
        }
    },[holidayData, holidayLoading]);

    useEffect(()=>{
        if(payStartDateTime && payEndDateTime){

            const response = calculateTimeDifference(payStartDateTime, payEndDateTime);   
            
            const isPayFirstDateInBankHoilday = holiday?.find((bh)=>(payStartDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, 'YYYY-MM-DD').format("DD/MM/YYYY")) ? true : false ;
            const isPaySecondDateInBankHoilday = holiday?.find((bh)=>(payEndDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false ;
            
            const payInput = {
                _id: scheduleId,
                payFirstDateHour: response?.firstDateHours?.toString(),
                isPayFirstDateInBankHoilday,
                paySecondDateHour: response?.secondDateHours?.toString(),
                isPaySecondDateInBankHoilday,
                payStartDateTime,
                payEndDateTime,
                payHourTypeId: payHourType || hourTypeFallback,
                payDutyTypeId: payDutyType
            }
            if(updatePay){
                updatePayBill(payInput);
            }
        }
    }, [payDutyType, payHourType, payStartDateTime, payEndDateTime, updatePay]);

    

    // bill state
    const [billStartDateTime, setBillStartDateTime] = useState(null);
    const [billEndDateTime, setBillEndDateTime] = useState(null);
    const [billDutyType, setBillDutyType] = useState(null);
    const [billHourType, setBillHourType] = useState(null);
    const [billCustomerId, setBillCustomerId] = useState(null);

    
    useEffect(()=>{
        if(billStartDateTime && billEndDateTime){

            const response = calculateTimeDifference(billStartDateTime, billEndDateTime);   
            
            const isBillFirstDateInBankHoilday = holiday?.find((bh)=>(billStartDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false ;
            const isBillSecondDateInBankHoilday = holiday?.find((bh)=>(billEndDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false ;
            
            const billInput = {
                _id: scheduleId,
                billFirstDateHour: response?.firstDateHours.toString(),
                isBillFirstDateInBankHoilday,
                billSecondDateHour: response?.secondDateHours.toString(),
                isBillSecondDateInBankHoilday,
                billStartDateTime,
                billEndDateTime,
                billHourTypeId: billHourType || hourTypeFallback,
                billDutyTypeId: billDutyType
            }
            if(updateBill){
                updatePayBill(billInput);
            }
        }
    }, [billDutyType, billHourType, billStartDateTime, billEndDateTime, updateBill]);

    const updatePayBill = async(input)=>{
        await updateSchedule({
            variables:{
                input
            }
        }); 
        setChangePayBill(false);
        setUpdateBill(false);
        setUpdatePay(false);
        await scheduleJobRefetch();
    }

    const updatePayBillOnChange = async()=>{

        let billresponse;
        if(billStartDateTime && billEndDateTime){
            billresponse = calculateTimeDifference(billStartDateTime, billEndDateTime);   
        }
            
        const isBillFirstDateInBankHoilday = billStartDateTime? holiday?.find((bh)=>(billStartDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false : false;
        const isBillSecondDateInBankHoilday = billEndDateTime? holiday?.find((bh)=>(billEndDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false : false ;
            
            
        let payResponse;   
        if(payStartDateTime && payEndDateTime){
            payResponse = calculateTimeDifference(payStartDateTime, payEndDateTime);    
        }
        const isPayFirstDateInBankHoilday = payStartDateTime? holiday?.find((bh)=>(payStartDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false : false ;
        const isPaySecondDateInBankHoilday = payEndDateTime? holiday?.find((bh)=>(payEndDateTime).format("DD/MM/YYYY")==dayjs(bh?.date, "YYYY-MM-DD").format("DD/MM/YYYY")) ? true : false : false;
        
       
       
        const payBillInput = {
            _id: scheduleId,

            billFirstDateHour: billresponse?.firstDateHours.toString() || null,
            isBillFirstDateInBankHoilday,
            billSecondDateHour: billresponse?.secondDateHours.toString() || null,
            isBillSecondDateInBankHoilday,
            billStartDateTime,
            billEndDateTime,
            billHourTypeId: billHourType || hourTypeFallback || null,
            billDutyTypeId: billDutyType || null,

            payFirstDateHour: payResponse?.firstDateHours?.toString() || null,
            isPayFirstDateInBankHoilday,
            paySecondDateHour: payResponse?.secondDateHours?.toString() || null,
            isPaySecondDateInBankHoilday,
            payStartDateTime: payStartDateTime,
            payEndDateTime: payEndDateTime,
            payHourTypeId: payHourType || hourTypeFallback || null,
            payDutyTypeId: payDutyType || null,

        };

        await updatePayBill(payBillInput);


    }; 

    // const originalRow = document.querySelector(`#timesTable #${rowId}`);


    const handleDragStart = (event, rowId) => {
        event.stopPropagation();
        event.dataTransfer.setData('rowId', rowId);
        event.dataTransfer.effectAllowed = 'move';
        
        const originalRow = document.querySelector(`#timesTable #${rowId}`);
        
        if (!originalRow) return;
    
        // Create a container that mimics the table structure
        const dragImageContainer = document.createElement('div');
        dragImageContainer.style.position = 'fixed';
        dragImageContainer.style.top = '-9999px';
        dragImageContainer.style.left = '-9999px';
        dragImageContainer.style.zIndex = '9999';
        dragImageContainer.style.pointerEvents = 'none';
        dragImageContainer.style.background = "#f5f8fa";

        // Create a table structure to preserve table row styling
        const table = document.createElement('table');
        const tbody = document.createElement('tbody');
        const clone = originalRow.cloneNode(true);
        
        // Copy all inline styles
        const computedStyle = window.getComputedStyle(originalRow);
        for (let i = 0; i < computedStyle.length; i++) {
            const prop = computedStyle[i];
            clone.style[prop] = computedStyle.getPropertyValue(prop);
        }
        
        // Preserve cell widths
        const cells = originalRow.querySelectorAll('td, th');
        const cloneCells = clone.querySelectorAll('td, th');
        cells.forEach((cell, index) => {
            if (index < cloneCells.length) {
                const cellStyle = window.getComputedStyle(cell);
                for (let i = 0; i < cellStyle.length; i++) {
                    const prop = cellStyle[i];
                    cloneCells[index].style[prop] = cellStyle.getPropertyValue(prop);
                }
                cloneCells[index].style.width = `${cell.offsetWidth}px`;
            }
        });
    
        // Set fixed width for the clone
        clone.style.width = `${originalRow.offsetWidth}px`;
        clone.style.margin = '0';
        clone.style.padding = '0';
        clone.style.boxSizing = 'border-box';
        
        // Build the structure
        tbody.appendChild(clone);
        table.appendChild(tbody);
        dragImageContainer.appendChild(table);
        document.body.appendChild(dragImageContainer);
        
        // Calculate position for the drag image
        const rect = originalRow.getBoundingClientRect();
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        
        // Set the drag image
        event.dataTransfer.setDragImage(dragImageContainer, x, y);
        
        // Clean up
        setTimeout(() => {
            document.body.removeChild(dragImageContainer);
        }, 0);
    };


    // Function to handle drop event
    const handleDrop = (event, targetRowId) => {
        event.preventDefault();
        const draggedRowIdRaw = event.dataTransfer.getData('rowId');
        const draggedRowId = draggedRowIdRaw.split("-")[1];
        
        // Prevent cloning on the same row
        if (draggedRowId && draggedRowId !== targetRowId ) {
            // if scheduled drag over 
            if(draggedRowId==1){
                if(targetRowId==4){
                    // set pay state
                    setUpdatePay(true);

                    setPayStartDateTime( dayjs(scheduleData?.firstDate) );
                    setPayEndDateTime(
                        scheduleData?.secondDate? 
                        dayjs(scheduleData?.secondDate) : 
                        dayjs(scheduleData?.date+" "+scheduleData?.shiftEndTime, "DD/MM/YYYY HH:mm")
                    );
                    setPayDutyType(scheduleData?.dutyTypeId);
                    setPayHourType(scheduleData?.hourTypeId);
                    setPayEmployeeId(scheduleData?.assignedEmployee);
                }
                else{
                    // set bill state
                    setUpdateBill(true);
                    setBillStartDateTime( dayjs(scheduleData?.firstDate) );
                    setBillEndDateTime( 
                        
                        scheduleData?.secondDate? 
                        dayjs(scheduleData?.secondDate) : 
                        dayjs(scheduleData?.date+" "+scheduleData?.shiftEndTime, "DD/MM/YYYY HH:mm")

                     );
                    setBillDutyType(scheduleData?.dutyTypeId);
                    setBillHourType(scheduleData?.hourTypeId);
                    setBillCustomerId();
                }
            }
            // if opertional drag over 
            else if(draggedRowId==2){

                if(targetRowId==4){
                    setUpdatePay(true);

                    // set pay state
                    setPayStartDateTime(dayjs(operationalStartDateTime, "DD/MM/YYYY HH:mm"));
                    setPayEndDateTime(dayjs(operationalEndDateTime, "DD/MM/YYYY HH:mm"));
                    setPayDutyType(operationalDutyType);
                    setPayHourType(operationalHourType);
                    setPayEmployeeId(operationalAssignedEmployee);

                }
                else{
                    setUpdateBill(true);
                    // set bill state
                    setBillStartDateTime(dayjs(operationalStartDateTime, "DD/MM/YYYY HH:mm"));
                    setBillEndDateTime(dayjs(operationalEndDateTime, "DD/MM/YYYY HH:mm"));
                    setBillDutyType(operationalDutyType);
                    setBillHourType(operationalHourType);
                    setBillCustomerId();
                }

            }
            // if actual drag over on which emp clock-in clock-out
            else if(draggedRowId==3){

                if(targetRowId==4){
                    setUpdatePay(true);
                    // set pay state
                    setPayStartDateTime(dayjs(scheduleData?.scheduletimesDetail?.actualStartDate));
                    setPayEndDateTime(dayjs(scheduleData?.scheduletimesDetail?.actualEndDate));
                    setPayDutyType(operationalDutyType);
                    setPayHourType(operationalHourType);
                    setPayEmployeeId(operationalAssignedEmployee);

                }
                else{
                    setUpdateBill(true);
                    // set bill state
                    setBillStartDateTime(dayjs(scheduleData?.scheduletimesDetail?.actualStartDate));
                    setBillEndDateTime(dayjs(scheduleData?.scheduletimesDetail?.actualEndDate));
                    setBillDutyType(operationalDutyType);
                    setBillHourType(operationalHourType);
                    setBillCustomerId();
                }

            }

        }
    };

    // Function to allow dropping
    const handleDragOver = (event) => {
        event.preventDefault(); // Necessary to allow drop
    };

    const [warning, setWarningModal] = useState(false);

    
    const calculateTimeDifference = (time1, time2) => {
        // Define the start and end times
        const firstDate = dayjs(time1, 'DD/MM/YYYY HH:mm').second(0);
        const secondDate = dayjs(time2, 'DD/MM/YYYY HH:mm').second(0);

        if (firstDate.isSame(secondDate, 'day')) {
            // Case 1: Same day
            const firstDateHours = secondDate.diff(firstDate, 'hour', true);

            return {firstDateHours: firstDateHours, secondDateHours:0}

        } else {        
            // Case 2: Different days
            // 1. Calculate remaining hours in the first day (until midnight)
            const endOfFirstDay = firstDate.endOf('day') // Get the end of the first day (23:59:59)
            const hoursInFirstDay = endOfFirstDay.diff(firstDate, 'hour', true); // Convert diff to hours
          
            // 2. Calculate hours on the second day (from midnight to the second date)
            const startOfSecondDay = secondDate.startOf('day'); // Midnight of the second day
            const hoursInSecondDay = secondDate.diff(startOfSecondDay, 'hour', true); // Convert diff to hours
          
            // Display the results;
            return {firstDateHours: hoursInFirstDay, secondDateHours: hoursInSecondDay}
        }


    }

    useEffect(()=>{
        if(payStartDateTime!=null && payEndDateTime!=null){
            const {firstDateHours, secondDateHours} = calculateTimeDifference(payStartDateTime, payEndDateTime);
        }
    },[payStartDateTime, payEndDateTime]);

    useEffect(()=>{
        if(billStartDateTime!=null && billEndDateTime!=null){
            const {firstDateHours, secondDateHours} = calculateTimeDifference(billStartDateTime, billEndDateTime);
           
        }
    },[billStartDateTime, billEndDateTime]);


    const [payBillDisabled, setPayBillDisabled] = useState(true);
    useEffect(()=>{
        if(payStartDateTime || payEndDateTime || payDutyType || payHourType || billStartDateTime || 
            billEndDateTime || billDutyType || billHourType){
            setPayBillDisabled(false);
        }else{
            setPayBillDisabled(true);
        }
    },[payStartDateTime, payEndDateTime, payDutyType, payHourType, billStartDateTime, billEndDateTime, billDutyType, billHourType]);

    const [calculatePayBill, {loading:calculatePayBillLoading}] = useMutation(calculatePayBillMutation);

    // Just to know whether this duty has ever been calculated before - "Calculate Pay & Bill"
    // the first time, "Recalculate Pay & Bill" once one already exists.
    const {data: existingPayBillData, refetch: refetchExistingPayBill} = useQuery(getPayBillByScheduleIdQuery,{
        variables: { scheduleId },
        fetchPolicy: 'network-only',
        skip: !scheduleId
    });
    const payBillAlreadyCalculated = !!existingPayBillData?.getPayBill?.response;

    // Overtime (calculatePayBill -> overTimeProcess) is only correct when it sees every duty in
    // the employee's whole reset period at once - recalculating this duty alone would make the
    // engine treat it as the employee's only shift and silently drop any overtime it should
    // carry. So when the employee actually has an overtime policy set, widen the recalculation
    // to their whole day/week/month instead of just this one duty. No policy set (or a value we
    // don't recognise) -> ignore this entirely and recalculate just this duty, same as before.
    const handelPayBill = async()=>{
        try{

            const overtimePolicy = scheduleData?.assignedEmployeeDetail?.metadata?.overtimepolicy;
            const employeeId = scheduleData?.assignedEmployee;

            let input = { scheduleIds: [scheduleId] };
            let scopeNote = "";

            if(overtimePolicy && employeeId && scheduleData?.firstDate){
                const anchor = dayjs(scheduleData.firstDate);
                let rangeStart, rangeEnd, periodLabel;

                if(overtimePolicy === "Daily Overtime"){
                    rangeStart = anchor.startOf('day');
                    rangeEnd = anchor.endOf('day');
                    periodLabel = "day";
                }else if(overtimePolicy === "Weekly Overtime"){
                    rangeStart = anchor.startOf('isoWeek');
                    rangeEnd = anchor.endOf('isoWeek');
                    periodLabel = "week";
                }else if(overtimePolicy === "Monthly Overtime"){
                    rangeStart = anchor.startOf('month');
                    rangeEnd = anchor.endOf('month');
                    periodLabel = "month";
                }

                if(rangeStart && rangeEnd){
                    input = {
                        employeeIds: [employeeId],
                        startDate: rangeStart.format("DD/MM/YYYY"),
                        endDate: rangeEnd.format("DD/MM/YYYY"),
                    };
                    scopeNote = ` (recalculated the employee's whole ${periodLabel} to keep overtime correct)`;
                }
            }

            await calculatePayBill({
                variables: { input }
            });
            await refetchExistingPayBill();

            dispatch(setNotification({
                error: false,
                notificationState: true,
                message: `Pay & Bill was calculated successfully${scopeNote}`
            }));
        }
        catch(err){
            dispatch(setNotification({
                error: true,
                notificationState: true,
                message: err?.message || "An error encountered while calculating pay/bill"
            }));
        }

    };

    const [isEmployeeAssigneeToChange, setIsAssigneeIntentToChange] = useState(false);
   

    // handel cancel duty
    const [cancelledDuty, setCancelledDuty] = useState({});

    const handelDutyCancel = (job)=>{
        setCancelledDuty(job);
    }


    return(
        
        <div className="box-shadow border-radius">

            <div style={{padding:'16px'}}>
                <div className='hr-info-title'>
                    Duty Times
                </div>
            </div>

            {calculatePayBillLoading || dutyTypeLoading || hourTypeDataLoading || newScheduleLoading || updateScheduleLoading || scheduledJobLoading?
                
                <div style={{display:'table', margin:'auto'}}>
                    <Spinner/>
                </div>
                :
                Object.keys(scheduleData)?.length>0?


                <table className="times" id="timesTable" cellPadding={5}>
                    <thead>
                        <th>Type</th>
                        <th>Start</th>
                        <th>Finish</th>
                        <th>Duty Type</th>
                        {SHOW_HOUR_TYPE && <th>Hour Type</th>}
                        <th>Employee</th>
                    </thead>

                    <tbody>
                        
                        <tr
                            key={1}
                            id={'row-1'}
                            draggable
                            draggedRowId={1}
                            onDragStart={(e)=>handleDragStart(e, 'row-1')}
                            style={{cursor:'grab'}}
                        >
                            <td>Scheduled</td>
                            {/* start date and time */}
                            <td>

                            {/* {convertToLocalTime(scheduleData?.firstDate, scheduleData?.shiftStartTime)} */}
                            {dayjs.utc(scheduleData?.firstDate).tz(timezone).format("DD/MM/YYYY HH:mm")}
                                
                            </td>

                            {/* finish date and time */}
                            <td>
                                {/* {
                                    scheduleData?.secondDate?
                                        convertToLocalTime(scheduleData?.secondDate , scheduleData?.shiftEndTime)
                                    :
                                        convertToLocalTime(scheduleData?.shiftEndDateTime , scheduleData?.shiftEndTime)
                                } */}
                                {
                                    scheduleData?.secondDate?
                                        dayjs(scheduleData?.secondDate).tz(timezone).format("DD/MM/YYYY HH:mm")
                                    :
                                        dayjs(scheduleData?.shiftEndDateTime).tz(timezone).format("DD/MM/YYYY HH:mm")
                                }
                            </td>

                            {/* Duty Type */}
                            <td>
                                {scheduleData?.dutyTypeDetail[0]?.name}
                            </td>

                            {/* Hour Type */}
                            {SHOW_HOUR_TYPE &&
                            <td>
                                {scheduleData?.hourTypeDetail[0]?.name}
                            </td>
                            }

                            {/* Select Employee */}
                            <td style={{display:'flex', columnGap:'5px', alignItems:'center'}}>
                                {
                                scheduleData?.assignedEmployeeDetail?
                                <>
                                    {
                                        scheduleData?.assignedEmployeeDetail?.metadata?.imageURL?
                                        <div className="employeeProfile">
                                            <Avatar size={40} src={scheduleData?.assignedEmployeeDetail?.metadata?.imageURL} />
                                        </div>

                                        :
                                        <div className="employeeProfile">
                                            <Avatar size={40} style={{fontSize:'10px'}}> <UserOutlined/> </Avatar>
                                        </div>
                                    
                                    }
                                
                                    {scheduleData?.assignedEmployeeDetail?.firstname+" "+(scheduleData?.assignedEmployeeDetail?.lastname || "")}
                            
                                </>
                                : "No employee assigned"
                                }
                            </td>
                            
                        </tr>

                        {
                            scheduleData?.scheduletimesDetail?.actualStartDate && scheduleData?.scheduletimesDetail?.actualEndDate?
                            <tr
                                
                                key={2}
                                id={'row-2'}
                                draggable
                                draggedRowId={2}
                                onDragStart={(e)=>handleDragStart(e, 'row-2')}
                                style={{cursor:'grab'}}
                            >
                                <td>Operational</td>
                                {/* start date and time */}
                                <td>

                                    {/* <DatePicker
                                        className="generic-input-control"
                                        showTime
                                        showToday
                                        style={{marginTop:'-4px'}}
                                        format={"DD/MM/YYYY HH:mm"}
                                        suffixIcon={null}
                                        disabledDate={(currentDate)=> ![dayjs(operationalStartDateTime)].some((date) => currentDate.isSame(date, "day"))}
                                        value={dayjs(operationalStartDateTime).format("DD/MM/YYYY HH:mm")=="Invalid Date"? dayjs(operationalStartDateTime) : dayjs(operationalStartDateTime, "DD/MM/YYYY HH:mm")}
                                        onChange={(e, dateTimeString)=>  dateTimeString?.length>0 ? setOpertionalStartDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setOpertionalStartDateTime(null)}
                                    /> */}
                                    {dayjs.utc(operationalStartDateTime).tz(timezone).format("DD/MM/YYYY HH:mm")}
                                
                                </td>

                                {/* finish date and time */}
                                <td>

                                    {/* <DatePicker
                                        showTime
                                        showToday
                                        suffixIcon={null}
                                        disabledDate={disabledDate}
                                        format={"DD/MM/YYYY HH:mm"}
                                        className="generic-input-control"
                                        style={{marginTop:'-4px'}}
                                        value={dayjs(operationalEndDateTime).format("DD/MM/YYYY HH:mm")=="Invalid Date"? operationalEndDateTime : dayjs(operationalEndDateTime, "DD/MM/YYYY HH:mm")}
                                        onChange={(e, dateTimeString)=>  dateTimeString?.length>0 ? setOpertionalEndDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setOpertionalEndDateTime(null)}
                                    />
                                     */}

                                    {dayjs.utc(operationalEndDateTime).tz(timezone).format("DD/MM/YYYY HH:mm")}
                                </td>

                                {/* Duty Type */}
                                <td>
                                    {/* <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Duty type"
                                        clearIcon
                                        className="custom-select schedule-section" 
                                        suffixIcon={<span className="dropdowncaret"></span>}
                                        style={{width:'100%'}}
                                        loading={dutyTypeLoading}
                                        value={dutyTypeData?.getPayLevel?.response?.find((dutyType)=>dutyType?._id==operationalDutyType)?.name}
                                        onChange={(e)=>setOperationalDutyType(e)}
                                    >
                                        {dutyTypeData?.getPayLevel?.response?.map((dutyTypeData)=>(
                                            <Select.Option value={dutyTypeData?._id}>{dutyTypeData?.name}</Select.Option>
                                        ))}
                                    </Select> */}
                                    {dutyTypeData?.getPayLevel?.response?.find((dutyType)=>dutyType?._id==operationalDutyType)?.name}
                                    
                                </td>

                                {/* Hour Type */}
                                {SHOW_HOUR_TYPE &&
                                <td>
                                           
                                    {/* <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Hour type"
                                        className="custom-select schedule-section" 
                                        suffixIcon={<span className="dropdowncaret"></span>}
                                        style={{width:'-webkit-fill-available', cursor:'none'}}
                                        loading={hourTypeDataLoading}
                                        value={hourTypeData?.getShiftType?.response?.find((hourType)=>hourType?._id==operationalHourType)?.name}
                                        onChange={(e)=>setOperationalHourType(e)}
                                        status=""
                                    > */}
                                        {/* {hourTypeData?.getShiftType?.response?.map((hour)=>(
                                            <Option value={hour?._id}>{hour?.name}</Option>
                                        ))}
                                    </Select> */}
                                    {hourTypeData?.getShiftType?.response?.find((hourType)=>hourType?._id==operationalHourType)?.name}
                                    
                                </td>
                                }

                                {scheduleData?.scheduletimesDetail && isEmployeeAssigneeToChange==false &&
                                // {/* Select Employee */}
                                    <>
                                    {
                                        scheduleData?.OperationalTimeDetail?
                                            <td style={{display:'flex', columnGap:'5px', alignItems:'center'}}>
                                                
                                                {
                                                    scheduleData?.OperationalTimeDetail?.metadata?.imageURL?
                                                    <div className="employeeProfile">
                                                        <Avatar size={40} src={scheduleData?.OperationalTimeDetail?.metadata?.imageURL} />
                                                    </div>
                                                    :
                                                    <div className="employeeProfile">
                                                        <Avatar size={40} style={{fontSize:'10px'}}> <UserOutlined/> </Avatar>
                                                    </div>

                                                }
                                                <span>
                                                    {
                                                    scheduleData?.OperationalTimeDetail?.firstname 
                                                    } {scheduleData?.OperationalTimeDetail?.lastname || ""}
                                                </span>
                                            </td>
                                        :
                                        assignedAgency?
                                            <td style={{display:'flex', columnGap:'5px', alignItems:'center'}}>
                                                <div className="employeeProfile">
                                                    <Avatar size={40} style={{background:'lightgrey', fontSize:'12px', fontWeight:'400'}} >
                                                        <div style={{marginTop:'-5px'}}>A</div>
                                                    </Avatar>
                                                </div>
                                                <span>
                                                    
                                                    {agencyData?.agencies?.agencies?.find((agency)=>agency?._id==assignedAgency)?.suppliername}
                                                    
                                                </span>
                                            </td>
                                        :
                                        <div style={{width:'100%'}}>
                                                    
                                                    {
                                                        operationalAssignedEmployee?
                                                        <Tag closable onClose={()=>{ setOperationalAssignedEmployee(); setAssignedAgency(null); setAssignAgencyLocally(null); }} style={{marginBottom:'6px', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', height:'38px'}}>
                                                            <div style={{display:'flex', columnGap:'10px', alignItems:'center'}}>
                                                                <div className="employeeProfile">
                                                                    <Avatar size={30} style={{background:'lightgrey'}} src={operationalAssignedEmployee?.emp?.metadata?.imageURL || <UserOutlined/>} />
                                                                </div>
                                                                <div style={{fontSize:'14px'}}>
                                                                    {operationalAssignedEmployee?.emp?.firstname} {operationalAssignedEmployee?.emp?.lastname || ""}
                                                                </div>
                                                            </div>
                                                        </Tag>
                                                        :

                                                        scheduleData?.assignedAgencyDetail?
                                                        
                                                        <Tag closable onClose={()=>{ setOperationalAssignedEmployee(); setAssignedAgency(null); setAssignAgencyLocally(null); }} style={{marginBottom:'6px', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', height:'38px'}}>
                                                            <div style={{display:'flex', columnGap:'10px', alignItems:'center'}}>
                                                            <div className="employeeProfile">
                                                                    <Avatar size={30} style={{background:'lightgrey', fontSize:'12px', fontWeight:'400'}} >
                                                                        <div style={{marginTop:'-5px'}}>A</div>
                                                                    </Avatar>
                                                                </div>
                                                                <div style={{fontSize:'14px'}}>
                                                                    {agencyData?.agencies?.agencies?.find((agency)=>agency?._id==assignedAgency)?.suppliername}
                                                                </div>
                                                            </div>
                                                        </Tag>

                                                        :
                                                        
                                                        <div style={{width:'100%'}}>

                                                            <Dropdown
                                                                id="searchpopup"
                                                                placement="bottom"
                                                                overlayClassName='associationCustomDropdown'
                                                                trigger={["click"]}
                                                                dropdownRender={()=>(
                                                                    <div className="association" ref={associationDropdownRef}>
                                                                        <div className="association-sidebar" ref={searchSegmentRef}>

                                                                            <div className="popoverdataitem">
                                                                                Select
                                                                            </div>

                                                                            <Divider style={{marginTop:'0px', marginBottom:'10px'}}/>

                                                                            <Menu
                                                                                selectable
                                                                                selectedKeys={[activeAssociatedModule]}
                                                                                onClick={({key})=>{
                                                                                    setSearch("");
                                                                                    if(key=="employee") setEmpSearchResult([]);
                                                                                    setActiveAssociateModule(key);
                                                                                }}
                                                                                items={[
                                                                                    {key:"employee", label:"Employee", className: activeAssociatedModule=="employee"? "popoverdataitem activeTab" :"popoverdataitem"},
                                                                                    {key:"agency", label:"Supplier Staff", className: activeAssociatedModule=="agency"? "popoverdataitem activeTab" :"popoverdataitem"},
                                                                                ]}
                                                                            />
                                                                        </div>

                                                                        <div className="association-body" ref={searchDetailSegmentRef}>
                                                                            {activeAssociatedModule=="employee" &&
                                                                                <Input
                                                                                    type="search"
                                                                                    id="inputSearch"
                                                                                    name='popoverSearch'
                                                                                    style={{ width: '-webkit-fill-available', margin:'8px 8px 16px 8px' }}
                                                                                    className='generic-input-control'
                                                                                    placeholder={"Search "+activeAssociatedModule}
                                                                                    autoFocus={searchPopup || true}
                                                                                    autoComplete="off"
                                                                                    value={search}
                                                                                    onChange={(e)=>setSearch(e.target.value)}
                                                                                    suffix={<FontAwesomeIcon style={{color:'#0091ae'}}  icon={faSearch}/>}
                                                                                />
                                                                            }
                                                                            <div  style={{overflowY:'scroll',  }}>

                                                                                {
                                                                                    activeAssociatedModule=="employee"?
                                                                                    empSearchDataLoading?
                                                                                    <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                                                                        <Spinner />
                                                                                    </div>
                                                                                    :
                                                                                    <Menu
                                                                                        selectable={false}
                                                                                        onClick={({key})=>{
                                                                                            const employee = EmployeeSearchResult?.find((emp)=>emp?._id==key);
                                                                                            setSearchPopup(false); setFailureChecks(null); checkEmployeeIfSuitable(employee);
                                                                                        }}
                                                                                        items={EmployeeSearchResult?.map((employee)=>{

                                                                                            const lastname = employee?.lastname? employee?.lastname : "";
                                                                                            const firstname = employee?.firstname? employee?.firstname : "";

                                                                                            return({
                                                                                                key: employee?._id,
                                                                                                className: "popoverdataitem",
                                                                                                label: (
                                                                                                    <div style={{display:'flex', columnGap:'12px'}}>
                                                                                                        <div className="employeeProfile">
                                                                                                            <Avatar  size={40} style={{background:'lightgrey'}} src={employee?.metadata?.imageURL || <UserOutlined/>} />
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            <div>{firstname +" "+ lastname}</div>
                                                                                                            <div style={{color:'grey', fontWeight:300}}>{employee?.metadata?.employmenttype} {employee?.metadata?.agency[0]?.suppliername?  "["+ employee?.metadata?.agency[0]?.suppliername +"]" : null }</div>

                                                                                                        </div>
                                                                                                    </div>
                                                                                                )
                                                                                            })
                                                                                        }) || []}
                                                                                    />
                                                                                    :

                                                                                    <div className="addDutyAgencySelect">

                                                                                        <Form.Item>
                                                                                            <Select
                                                                                                allowClear
                                                                                                showSearch
                                                                                                optionFilterProp="children"
                                                                                                className="custom-select"
                                                                                                style={{width:'98%'}}
                                                                                                placeholder="Search supplier"
                                                                                                suffixIcon={agencyLoading? <Spinner/> :<div className="dropdowncaret"></div>}
                                                                                                loading={agencyLoading}
                                                                                                onChange={(e)=>{setAssignAgencyLocally(e); setAssignedEmployee(null);}}
                                                                                            >
                                                                                                {!agencyLoading && agencyData?.agencies?.agencies?.length>0?
                                                                                                    agencyData?.agencies?.agencies?.map((agency, index)=>{
                                                                                                        return(
                                                                                                            <Option key={index} value={agency?._id}>{agency?.suppliername}</Option>
                                                                                                        )
                                                                                                    })
                                                                                                    :
                                                                                                    <Option disabled>No suppliers found</Option>
                                                                                                }
                                                                                            </Select>
                                                                                            {
                                                                                                assignAgencyLocally &&
                                                                                                <button className="drawer-filled-btn" onClick={()=>{setAssignedAgency(assignAgencyLocally);setSearchPopup(false);}} > Assign to supplier</button>
                                                                                            }
                                                                                        </Form.Item>


                                                                                        {
                                                                                            assignAgencyLocally &&
                                                                                            <Form.Item>
                                                                                                <Select
                                                                                                    showSearch
                                                                                                    optionFilterProp="children"
                                                                                                    className="custom-select"
                                                                                                    style={{width:'98%'}}
                                                                                                    placeholder="Select Employee"
                                                                                                    suffixIcon={agencyEmployeeLoading? <Spinner/> :<div className="dropdowncaret"></div>}
                                                                                                    loading={agencyEmployeeLoading}
                                                                                                    disabled={agencyEmployeeLoading}
                                                                                                    value={assignedEmployee && assignedEmployee?._id}
                                                                                                    onChange={(e)=>{setSearchPopup(false); setFailureChecks(null); checkEmployeeIfSuitable(agencyEmployee?.getEmployeeForScheduleSearch?.response?.find((emp)=>emp?._id==e));}}
                                                                                                >
                                                                                                    {
                                                                                                        agencyEmployee?.getEmployeeForScheduleSearch?.response?.map((employee)=>{
                                                                                                            return(
                                                                                                                <Option value={employee?._id}>{employee?.firstname} {employee?.lastname || ""}</Option>
                                                                                                            )
                                                                                                        })

                                                                                                    }

                                                                                                </Select>
                                                                                            </Form.Item>

                                                                                        }


                                                                                    </div>

                                                                                }
                                                                            </div>
                                                                        </div>


                                                                    </div>
                                                                )}
                                                                open={searchPopup}
                                                            >
                                                                <Input
                                                                    className="generic-input-control"
                                                                    readOnly={true}
                                                                    suffix={<span className="caret"></span>}
                                                                    style={{cursor:'pointer', fontWeight:'400', fontSize:'14px', color:'gray'}}
                                                                    value={assignedAgency? "1 Agency Allocated": assignedEmployee? "1 Employee Allocated" :" Employee / Agency Allocate"}
                                                                    onClick={()=>setSearchPopup(!searchPopup)}
                                                                    ref={searchRef}
                                                                />

                                                            </Dropdown>


                                                        </div>
                                                    }
                                                    
                                        </div>
                                    }
                                    </>
                                }
                                
                            </tr>
                            :
                            <tr>
                                <td>Operational</td>
                                
                                <td>
                                    <DatePicker
                                        className="generic-input-control"
                                        showTime
                                        showToday
                                        style={{marginTop:'-4px'}}
                                        format={"DD/MM/YYYY HH:mm"}
                                        suffixIcon={null}
                                        // disabledDate={(currentDate)=> ![dayjs(scheduleData?.firstDate)].some((date) => currentDate.isSame(date, "day"))}
                                        value={operationalStartDateTime}
                                        onChange={(e, dateTimeString)=>  dateTimeString?.length>0 ? setOpertionalStartDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setOpertionalStartDateTime(null)}
                                    />
                                </td>

                                <td>
                                    <DatePicker
                                        showTime
                                        showToday
                                        suffixIcon={null}
                                        // disabledDate={disabledDate}
                                        format={"DD/MM/YYYY HH:mm"}
                                        className="generic-input-control"
                                        style={{marginTop:'-4px'}}
                                        value={operationalEndDateTime}
                                        onChange={(e, dateTimeString)=>  dateTimeString?.length>0 ? setOpertionalEndDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setOpertionalEndDateTime(null)}
                                    />
                                </td>

                                <td>
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Duty type"
                                        clearIcon
                                        className="custom-select schedule-section" 
                                        suffixIcon={<span className="dropdowncaret" style={{marginTop:'-20px'}}></span>}
                                        style={{width:'100%', marginTop:0}}
                                        loading={dutyTypeLoading}
                                        value={operationalDutyType}
                                        onChange={(e)=>setOperationalDutyType(e)}
                                    >
                                        {/* guarding types at a customer site, every type at an internal site (the duty's own stays) */}
                                        {dutyTypesForSite(dutyTypeData?.getPayLevel?.response, scheduleData?.site, operationalDutyType)?.map((dutyTypeData)=>(
                                            <Select.Option value={dutyTypeData?._id}>{dutyTypeData?.name}</Select.Option>
                                        ))}
                                    </Select>
                                </td>

                                {SHOW_HOUR_TYPE &&
                                <td>          
                                    <Select
                                        showSearch
                                        optionFilterProp="children"
                                        placeholder="Hour type"
                                        className="custom-select schedule-section" 
                                        suffixIcon={<span className="dropdowncaret" style={{marginTop:'-20px'}}></span>}
                                        style={{width:'-webkit-fill-available', cursor:'none', marginTop:0}}
                                        loading={hourTypeDataLoading}
                                        value={operationalHourType}
                                        onChange={(e)=>setOperationalHourType(e)}
                                    >
                                        {hourTypeData?.getShiftType?.response?.map((hour)=>(
                                            <Option value={hour?._id}>{hour?.name}</Option>
                                        ))}
                                    </Select>
                                </td>
                                }

                                <td>

                                    <div style={{width:'100%'}}>
                                            
                                            {
                                                operationalAssignedEmployee?
                                
                                                <Tag closable onClose={()=>{ setOperationalAssignedEmployee(); setAssignedAgency(null); setAssignAgencyLocally(null); }} style={{marginBottom:'6px', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', height:'38px'}}>
                                                    <div style={{display:'flex', columnGap:'10px', alignItems:'center'}}>
                                                        <div className="employeeProfile">
                                                            <Avatar size={30} style={{background:'lightgrey'}} src={operationalAssignedEmployee?.emp?.metadata?.imageURL || <UserOutlined/>} />
                                                        </div>
                                                        <div style={{fontSize:'14px'}}>
                                                            {operationalAssignedEmployee?.emp?.firstname} {operationalAssignedEmployee?.emp?.lastname || ""}
                                                            
                                                        </div>
                                                    </div>
                                                </Tag>
                                                :

                                                assignedAgency?
                                                
                                                <Tag closable onClose={()=>{ setOperationalAssignedEmployee(); setAssignedAgency(null); setAssignAgencyLocally(null); }} style={{marginBottom:'6px', display:'flex', alignItems:'center', justifyContent:'space-between', width:'100%', height:'38px'}}>
                                                    <div style={{display:'flex', columnGap:'10px', alignItems:'center'}}>
                                                    <div className="employeeProfile">
                                                            <Avatar size={30} style={{background:'lightgrey', fontSize:'12px', fontWeight:'400'}} >
                                                                <div style={{marginTop:'-5px'}}>A</div>
                                                            </Avatar>
                                                        </div>
                                                        <div style={{fontSize:'14px'}}>
                                                            {agencyData?.agencies?.agencies?.find((agency)=>agency?._id==assignedAgency)?.suppliername}
                                                        </div>
                                                    </div>
                                                </Tag>

                                                :
                                                
                                                <div style={{width:'100%'}}>

                                                    <Dropdown
                                                        id="searchpopup"
                                                        placement="bottom"
                                                        overlayClassName='employeeScheduleSearchDropdown'
                                                        trigger={["click"]}
                                                        dropdownRender={()=>(
                                                            <div style={{}} ref={associationDropdownRef}>
                                                                <div style={{height:'auto', display:'flex',}}>
                                                                    <div className="association-sidebar" ref={searchSegmentRef}>

                                                                        <div className="popoverdataitem">
                                                                            Select
                                                                        </div>

                                                                        <Divider style={{marginTop:'0px', marginBottom:'10px'}}/>

                                                                        <Menu
                                                                            selectable
                                                                            selectedKeys={[activeAssociatedModule]}
                                                                            onClick={({key})=>{
                                                                                setSearch("");
                                                                                if(key=="employee") setEmpSearchResult([]);
                                                                                setActiveAssociateModule(key);
                                                                            }}
                                                                            items={[
                                                                                {key:"employee", label:"Employee", className: activeAssociatedModule=="employee"? "popoverdataitem activeTab" :"popoverdataitem"},
                                                                                {key:"agency", label:"Supplier Staff", className: activeAssociatedModule=="agency"? "popoverdataitem activeTab" :"popoverdataitem"},
                                                                            ]}
                                                                        />
                                                                    </div>

                                                                    <div className="association-body" ref={searchDetailSegmentRef}>
                                                                        {activeAssociatedModule=="employee" &&
                                                                            <Input
                                                                                type="search"
                                                                                id="inputSearch"
                                                                                name='popoverSearch'
                                                                                style={{ width: '-webkit-fill-available', margin:'8px 8px 16px 8px' }}
                                                                                className='generic-input-control'
                                                                                placeholder={"Search "+activeAssociatedModule}
                                                                                autoFocus={searchPopup || true}
                                                                                autoComplete="off"
                                                                                value={search}
                                                                                onChange={(e)=>setSearch(e.target.value)}
                                                                                suffix={<FontAwesomeIcon style={{color:'#0091ae'}}  icon={faSearch}/>}
                                                                            />
                                                                        }
                                                                        <div>

                                                                            {
                                                                                activeAssociatedModule=="employee"?
                                                                                empSearchDataLoading?
                                                                                <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                                                                                    <Spinner />
                                                                                </div>
                                                                                :
                                                                                <Menu
                                                                                    selectable={false}
                                                                                    onClick={({key})=>{
                                                                                        const employee = EmployeeSearchResult?.find((emp)=>emp?._id==key);
                                                                                        setSearchPopup(false); setFailureChecks(null); checkEmployeeIfSuitable(employee);
                                                                                    }}
                                                                                    style={{height:'300px'}}
                                                                                    items={EmployeeSearchResult?.map((employee)=>{

                                                                                        const lastname = employee?.lastname? employee?.lastname : "";
                                                                                        const firstname = employee?.firstname? employee?.firstname : "";

                                                                                        return({
                                                                                            key: employee?._id,
                                                                                            className: "popoverdataitem",
                                                                                            label: (
                                                                                                <div style={{display:'flex', columnGap:'12px'}}>
                                                                                                    <div className="employeeProfile">
                                                                                                        <Avatar  size={40} style={{background:'lightgrey'}} src={employee?.metadata?.imageURL || <UserOutlined/>} />
                                                                                                    </div>
                                                                                                    <div>
                                                                                                        <div>{firstname +" "+ lastname}</div>
                                                                                                        <div style={{color:'grey', fontWeight:300}}>{employee?.metadata?.employmenttype} {employee?.metadata?.agency[0]?.suppliername?  "["+ employee?.metadata?.agency[0]?.suppliername +"]" : null }</div>

                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    }) || []}
                                                                                />
                                                                                :

                                                                                <div className="addDutyAgencySelect">

                                                                                    <Form.Item>
                                                                                        <Select
                                                                                            allowClear
                                                                                            showSearch
                                                                                            optionFilterProp="children"
                                                                                            className="custom-select"
                                                                                            style={{width:'98%'}}
                                                                                            placeholder="Search supplier"
                                                                                            suffixIcon={agencyLoading? <Spinner/> :<div className="dropdowncaret" style={{marginTop:'-20px'}}></div>}
                                                                                            loading={agencyLoading}
                                                                                            onChange={(e)=>{setAssignAgencyLocally(e); setAssignedEmployee(null);}}
                                                                                        >
                                                                                            {!agencyLoading && agencyData?.agencies?.agencies?.length>0?
                                                                                                agencyData?.agencies?.agencies?.map((agency, index)=>{
                                                                                                    return(
                                                                                                        <Option key={index} value={agency?._id}>{agency?.suppliername}</Option>
                                                                                                    )
                                                                                                })
                                                                                                :
                                                                                                <Option disabled>No suppliers found</Option>
                                                                                            }
                                                                                        </Select>
                                                                                        {
                                                                                            assignAgencyLocally &&
                                                                                            <button className="drawer-filled-btn" onClick={()=>{setAssignedAgency(assignAgencyLocally); setOperationalAssignedEmployee(null); setSearchPopup(false);}} > Assign to supplier</button>
                                                                                        }
                                                                                    </Form.Item>


                                                                                    {
                                                                                        assignAgencyLocally &&
                                                                                        <Form.Item>
                                                                                            <Select
                                                                                                showSearch
                                                                                                optionFilterProp="children"
                                                                                                className="custom-select"
                                                                                                style={{width:'98%'}}
                                                                                                placeholder="Select Employee"
                                                                                                suffixIcon={agencyEmployeeLoading? <Spinner/> :<div className="dropdowncaret" style={{marginTop:'-20px'}}></div>}
                                                                                                loading={agencyEmployeeLoading}
                                                                                                disabled={agencyEmployeeLoading}
                                                                                                value={assignedEmployee && assignedEmployee?._id}
                                                                                                onChange={(e)=>{setSearchPopup(false); setFailureChecks(null); checkEmployeeIfSuitable(agencyEmployee?.getEmployeeForScheduleSearch?.response?.find((emp)=>emp?._id==e));}}
                                                                                            >
                                                                                                {
                                                                                                    agencyEmployee?.getEmployeeForScheduleSearch?.response?.map((employee)=>{
                                                                                                        return(
                                                                                                            <Option value={employee?._id}>{employee?.firstname} {employee?.lastname || ""}</Option>
                                                                                                        )
                                                                                                    })

                                                                                                }

                                                                                            </Select>
                                                                                        </Form.Item>

                                                                                    }


                                                                                </div>

                                                                            }
                                                                        </div>
                                                                    </div>


                                                                </div>
                                                                <div
                                                                    className="popoverdataitem"
                                                                    style={{ color: '#0091ae', fontWeight: 500, borderTop: '1px solid #f0f0f0' }}
                                                                    onClick={() => { setSearchPopup(false); setNewEmployeeData([]); setNewEmployeeModal(true); }}
                                                                >
                                                                    <FontAwesomeIcon icon={faPlus} style={{ marginRight: '8px' }} />
                                                                    Create new employee
                                                                </div>
                                                            </div>
                                                        )}
                                                        open={searchPopup}
                                                    >
                                                        <Input
                                                            className="generic-input-control"
                                                            readOnly={true}
                                                            suffix={<span className="caret"></span>}
                                                            style={{cursor:'pointer', fontWeight:'400', fontSize:'14px', color:'gray'}}
                                                            value={assignedAgency? "1 Agency Allocated": assignedEmployee? "1 Employee Allocated" :" Employee / Agency Allocate"}
                                                            onClick={()=>setSearchPopup(!searchPopup)}
                                                            ref={searchRef}
                                                        />

                                                    </Dropdown>

                                                    {newEmployeeModal && (
                                                        <FormDrawer
                                                            objectData={newEmployeeSchema}
                                                            objectLoading={newEmployeeObjectLoading}
                                                            visible={newEmployeeModal}
                                                            refetch={newEmployeeObjectRefetch}
                                                            setBtn={setNewEmployeeBtnEnable}
                                                            setData={setNewEmployeeData}
                                                            data={newEmployeeData}
                                                            isBtnEnable={newEmployeeBtnEnable}
                                                            isoverlay={newEmployeeOverlay}
                                                            setIsOverlay={setNewEmployeeOverlay}
                                                            loading={newEmployeeProcessLoading}
                                                            onClose={()=>setNewEmployeeModal(false)}
                                                            handelSubmit={handelNewEmployeeSubmit}
                                                            to={"/employee/editform"}
                                                            from={"/user/employee"}
                                                            title={objectType.Employee}
                                                            objectType={objectType.Employee}
                                                        />
                                                    )}

                                                </div>
                                            }

                                    </div>

                                </td>

                            </tr>
                        }



                    {/* actual time */}

                        <tr  
                            
                            key={3}
                            id={'row-3'}
                            draggable={scheduleData?.scheduletimesDetail?.actualEndDate? true: false}
                            draggedRowId={3}
                            onDragStart={(e)=>handleDragStart(e, 'row-3')}
                            style={{cursor:'grab'}}

                        >

                            <td>Actual</td>

                            <td> {scheduleData?.scheduletimesDetail?.actualStartDate? dayjs(scheduleData?.scheduletimesDetail?.actualStartDate).local().format("DD/MM/YYYY HH:mm") : "--"} </td>

                            <td> {scheduleData?.scheduletimesDetail?.actualEndDate? dayjs(scheduleData?.scheduletimesDetail?.actualEndDate).local().format("DD/MM/YYYY HH:mm") : "--"} </td>

                            <td> 
                                {scheduleData?.scheduletimesDetail?.actualStartDate? dutyTypeData?.getPayLevel?.response?.find((dutyType)=>dutyType?._id==operationalDutyType)?.name : "--"}
                            </td>

                            {SHOW_HOUR_TYPE &&
                            <td>                                     
                                {scheduleData?.scheduletimesDetail?.actualStartDate? hourTypeData?.getShiftType?.response?.find((hourType)=>hourType?._id==operationalHourType)?.name : "--"}   
                            </td>
                            }

                            <td> -- </td>

                        </tr>

                        <tr style={{ margin: '0 0 10% 0', display: 'block'}}></tr>
                        

                        {/* pay and bill section */}
                        

                        <tr
                            
                            key={4}
                            id={4}
                            onDrop={(e)=>handleDrop(e, 4)}
                            onDragOver={scheduleData?.scheduletimesDetail?.actualEndDate? handleDragOver : ()=>setWarningModal(true)}
                        >

                            <td>Pay</td>

                            <td> 
                                
                                <DatePicker
                                    className={"generic-input-control"}
                                    showTime
                                    showToday
                                    style={(payStartDateTime || !scheduleData?.scheduletimesDetail?.actualEndDate) ? {marginTop:'-4px'} : {marginTop:'-4px', border:'2px solid red'}}
                                    format={"DD/MM/YYYY HH:mm"}
                                    disabled={!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate}
                                    disabledDate={(currentDate)=> ![dayjs(scheduleData?.firstDate)].some((date) => currentDate.isSame(date, "day"))}
                                    value={payStartDateTime? payStartDateTime : null}
                                    suffixIcon={null}
                                    onChange={(e, dateTimeString)=> { dateTimeString?.length>0 ? setPayStartDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setPayStartDateTime(null); setChangePayBill(true);}}
                                />

                            </td>

                            <td> 
                                
                                <DatePicker
                                    className="generic-input-control"
                                    showTime
                                    showToday
                                    style={(payEndDateTime || !scheduleData?.scheduletimesDetail?.actualEndDate)? {marginTop:'-4px'} : {marginTop:'-4px', border:'2px solid red'}}
                                    format={"DD/MM/YYYY HH:mm"}
                                    suffixIcon={null}
                                    disabled={!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate}
                                    disabledDate={disabledDate}
                                    value={payEndDateTime}
                                    onChange={(e, dateTimeString)=> { dateTimeString?.length>0 ? setPayEndDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setPayEndDateTime(null); setChangePayBill(true); }}
                                />
                                    
                            </td>

                            <td> 
                                
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    className={(payDutyType|| !scheduleData?.scheduletimesDetail?.actualEndDate)? "custom-select" :"warning-select"}
                                    suffixIcon={<span className="dropdowncaret" style={{marginTop:'-20px'}}></span>}
                                    style={ {width:'100%', marginTop:'-12px'} }
                                    loading={dutyTypeLoading}
                                    placeholder="Select Duty Type"
                                    disabled={(!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate)}
                                    onChange={(e)=>{setPayDutyType(e);setChangePayBill(true);}}
                                    value={payDutyType}
                                >
                                    {dutyTypeData?.getPayLevel?.response?.map((dutyTypeData)=>(
                                        <Select.Option value={dutyTypeData?._id}>{dutyTypeData?.name}</Select.Option>
                                    ))}
                                </Select>

                            </td>
                            
                            {SHOW_HOUR_TYPE &&
                            <td> 
                                      
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    placeholder="Select Hour Type"
                                    className={(payHourType || !scheduleData?.scheduletimesDetail?.actualEndDate)? "custom-select": "warning-select"} 
                                    suffixIcon={<span className="dropdowncaret" style={{marginTop:'-20px'}}></span>}
                                    style={ {width:'-webkit-fill-available', cursor:'none', marginTop:'-12px'} }
                                    loading={hourTypeDataLoading}
                                    disabled={(!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate)}
                                    onChange={(e)=>{setPayHourType(e);setChangePayBill(true);}}
                                    value={payHourType}
                                >
                                    {hourTypeData?.getShiftType?.response?.map((hour)=>(
                                        <Option value={hour?._id}>{hour?.name}</Option>
                                    ))}
                                </Select>
                            </td>
                            }
                            
                            <td style={{display:'flex', columnGap:'5px', alignItems:'center'}}>
                                {
                                    scheduleData?.OperationalTimeDetail?
                                    <>
                                    {
                                        scheduleData?.OperationalTimeDetail?.metadata?.imageURL?
                                        <div className="employeeProfile">
                                            <Avatar size={40} src={scheduleData?.OperationalTimeDetail?.metadata?.imageURL} />
                                        </div>
                                        :
                                        <div className="employeeProfile">
                                            <Avatar size={40} style={{fontSize:'10px'}}> <UserOutlined/> </Avatar>
                                        </div>
                                    }
                                        <span>
                                            {
                                                scheduleData?.OperationalTimeDetail?.firstname+" "+(scheduleData?.OperationalTimeDetail?.lastname || "")
                                            }
                                        </span>
                                    </>
                                    :null
                                }
                            </td>


                        </tr>

                        

                        <tr
                            
                            key={5}
                            id={5}
                            onDrop={(e)=>handleDrop(e, 5)}                            
                            onDragOver={scheduleData?.scheduletimesDetail?.actualEndDate? handleDragOver : ()=>setWarningModal(true)}

                        >

                            <td>Bill</td>
                            
                            <td> 
                                
                                <DatePicker
                                    className="generic-input-control"
                                    showTime
                                    showToday
                                    style={(billStartDateTime || !scheduleData?.scheduletimesDetail?.actualEndDate)?{}:{border:'2px solid red'}}
                                    suffixIcon={null}
                                    format={"DD/MM/YYYY HH:mm"}
                                    disabled={!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate}
                                    disabledDate={(currentDate)=> ![dayjs(scheduleData?.firstDate)].some((date) => currentDate.isSame(date, "day"))}
                                    value={billStartDateTime}
                                    onChange={ (e, dateTimeString)=>{ dateTimeString?.length>0 ? setBillStartDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setBillStartDateTime(null); setChangePayBill(true); }}
                                />

                            </td>

                            <td> 
                                
                                <DatePicker
                                    className="generic-input-control"
                                    showTime
                                    showToday
                                    style={(billEndDateTime || !scheduleData?.scheduletimesDetail?.actualEndDate)?{}:{border: '2px solid red'}}
                                    format={"DD/MM/YYYY HH:mm"}
                                    suffixIcon={null}
                                    disabled={!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate}
                                    value={billEndDateTime}
                                    disabledDate={disabledDate}
                                    onChange={(e, dateTimeString)=>{ dateTimeString?.length>0 ? setBillEndDateTime(dayjs(dateTimeString, "DD/MM/YYYY HH:mm")) : setBillEndDateTime(null); setChangePayBill(true); }}
                                />
                                    
                            </td>

                            <td> 
                                
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    className={(billDutyType || !scheduleData?.scheduletimesDetail?.actualEndDate)?"custom-select" :"warning-select"}
                                    suffixIcon={<span className="dropdowncaret" style={{marginTop:'-20px'}}></span>}
                                    style={(billDutyType)?{width:'100%'}:{width:'100%'}}
                                    loading={dutyTypeLoading}
                                    disabled={!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate}
                                    onChange={(e)=>{setBillDutyType(e); setChangePayBill(true);}}
                                    value={billDutyType}
                                    placeholder="Select Duty Type"
                                >
                                    {dutyTypeData?.getPayLevel?.response?.map((dutyTypeData)=>(
                                        <Select.Option value={dutyTypeData?._id}>{dutyTypeData?.name}</Select.Option>
                                    ))}
                                </Select>

                            </td>
                            
                            {SHOW_HOUR_TYPE &&
                            <td> 
                                      
                                <Select
                                    showSearch
                                    optionFilterProp="children"
                                    className={(billHourType || !scheduleData?.scheduletimesDetail?.actualEndDate)? "custom-select" : "warning-select"}
                                    suffixIcon={<span className="dropdowncaret" style={{marginTop:'-20px'}}></span>}
                                    style={{width:'-webkit-fill-available', cursor:'none'}}
                                    loading={hourTypeDataLoading}
                                    disabled={!scheduleData?.OperationalTimeDetail || !scheduleData?.scheduletimesDetail?.actualEndDate}
                                    onChange={(e)=>{setBillHourType(e); setChangePayBill(true);}}
                                    value={billHourType}
                                    placeholder="Select Hour Type"
                                >
                                    {hourTypeData?.getShiftType?.response?.map((hour)=>(
                                        <Option value={hour?._id}>{hour?.name}</Option>
                                    ))}
                                </Select>
                            </td>
                            }
                            
                            <td style={{display:'flex', columnGap:'5px', alignItems:'center'}}>
                                
                            </td>


                        </tr>


                    </tbody>
                </table>

                :

                "Duty data is not currently available"
            
            
            }


{/* times footer */}
            <div 
                className="drawer-footer border-radius-bottom"
                style={{display:'flex', alignItems:'center', justifyContent:'space-between', margin:'-10px', marginTop:'58px'}}
            >
                <div>
                {scheduleData?.status=="0" || updateScheduleFieldLoading || scheduleData?.isDutyCancel || isCompleted?
                    
                        scheduleData?.status=="0"?
                        <button className="drawer-outlined-btn disabled-btn"> Employee not assigned </button>
                        :
                        <button className="drawer-outlined-btn disabled-btn">Duty {isCompleted? "Completed" :scheduleData?.isDutyCancel? "Cancelled" : "Actions"}</button>
                    

                :
                    <Popover
                        overlayClassName='notePopover'
                        content={
                            <div className='popover-data'>

                            {
                                scheduleData?.isPublished?
                                null
                                :
                                <div className="popoverdataitem"
                                    onClick={async()=>{
                                        await updateScheduleField({
                                            variables:{
                                                input:{
                                                    field: "isPublished",
                                                    value: true,
                                                    _id: scheduleData?._id,
                                                }
                                            }
                                        });
                                        await scheduleJobRefetch();
                                    }}
                                >
                                    Publish Duty
                                </div>

                            }

                            {(isOnDuty || isCompleted)?
                                null
                                :
                                // set status to 1 for confirmed status
                                // if it is 1 then status will be confirm
                                scheduleData?.status=="1"?
                                    <div className="popoverdataitem"
                                    onClick={async()=>{
                                        await updateScheduleField({
                                            variables:{
                                                input:{
                                                    field: "status",
                                                    value: "2",
                                                    _id: scheduleData?._id,
                                                }
                                            }
                                        });
                                        await scheduleJobRefetch();
                                    }}>
                                        Unconfirm Duty
                                    </div>
                                :
                                // set status to 1 for confirmed status
                                // if it is 1 then status will be confirm                  
                                    <div className="popoverdataitem"
                                        onClick={async()=>{
                                            await updateScheduleField({
                                                variables:{
                                                    input:{
                                                        field: "status",
                                                        value: "1",
                                                        _id: scheduleData?._id,
                                                    }
                                                }
                                            });
                                            await scheduleJobRefetch();
                                        }}
                                    >
                                        Confirm Duty
                                    </div>
                            }

                            {
                                authenticatedUserDetail?._id==process.env.REACT_APP_systemUserId &&
                                <div className="popoverdataitem"
                                    onClick={async()=>{
                                        await deleteSchedule({
                                            variables: {
                                                scheduleId: scheduleData?._id
                                            }
                                        });
                                        await scheduleJobRefetch();
                                        close();
                                    }}
                                >
                                    Delete Duty
                                </div>
                            }

                            {/*  */}
                            {
                                (scheduleData?.scheduletimesDetail) ? 
                                
                                    
                                
                                    scheduleData?.scheduletimesDetail?.actualEndDate? 
                                    null :
                                    <>    
                                        <Divider
                                            style={{margin:0}}
                                        />
                                        <div className="popoverdataitem" onClick={async ()=>{
                                            if(scheduleData?.status=="1"){

                                                handelDutyCancel(scheduleData);

                                            }else{
                                                
                                                await deleteSchedule({
                                                    variables: {
                                                        scheduleId: scheduleData?._id
                                                    }
                                                });
                                                await scheduleJobRefetch();
                                                
                                            }
                                        }}>
                                            {
                                                scheduleData?.status=="1"? 
                                                <span>  Cancel Duty</span> 
                                                
                                                : 
                                                <span>  Delete Duty</span>
                                            }
                                        </div>
                                    </>
                                    
                                
                                :null
                            }

                            </div>
                        }
                    >

                        {/* <button  
                            // disabled={updateScheduleFieldLoading || scheduleData?.status=="3"} 
                            className={'drawer-outlined-btn'}
                        >
                            {
                                updateScheduleFieldLoading || scheduleData?.status=="3"?
                                <>
                                    Duty Actions  <Spinner/>
                                </> 
                                :
                                <>
                                 Duty Actions <CaretDownFilled />
                                </>
                            }
                        </button> */}

                    </Popover>
                }
                    &emsp;

                    

                </div>

                
                    {/* scheduleData?.scheduletimesDetail?.actualStartDate?
                    <div className="row-flex">
                        <button disabled={payBillDisabled || calculatePayBillLoading} className={payBillDisabled || calculatePayBillLoading?"drawer-filled-btn disabled-btn": "drawer-filled-btn"} onClick={handelPayBill}>
                            {calculatePayBillLoading? <Spinner/> : "Pay / Bill"}
                        </button>
                        {changePayBill ? 
                        <button className="drawer-outlined-btn" style={{marginLeft:'15px'}} onClick={updatePayBillOnChange}>Update</button>
                        : null} 
                    </div>
                    :
                    <button disabled={false}  className={false? 'disabled-btn drawer-filled-btn':'drawer-filled-btn'} 
                        onClick={handelScheduleOpertaionTime}
                    >
                        {false? <Spinner/> : "Save"}
                    </button> */}
                
                <div className="row-flex">
                    {(()=>{
                        // calculatePayBill reads the pay/bill fields saved on the schedule, not these
                        // inputs - so while a pay/bill edit is unsaved (changePayBill) or a dragged-in
                        // row is still auto-saving (updatePay/updateBill), (re)calculating would rate
                        // the old values. Hide it until "Update pay bill" / the auto-save lands.
                        if(changePayBill || updatePay || updateBill) return null;

                        // calculatePayBill needs all four pay/bill start-end fields already set on
                        // the schedule (see paybill.service.ts's matchStage) - disable rather than
                        // let it fail with "There are no duties to calculate...".
                        const payBillReady = scheduleData?.payStartDateTime && scheduleData?.payEndDateTime
                            && scheduleData?.billStartDateTime && scheduleData?.billEndDateTime;
                        const overtimePolicy = scheduleData?.assignedEmployeeDetail?.metadata?.overtimepolicy;
                        const scopeHint = overtimePolicy === "Daily Overtime" ? "This will recalculate the employee's whole day, to keep overtime correct."
                            : overtimePolicy === "Weekly Overtime" ? "This will recalculate the employee's whole week, to keep overtime correct."
                            : overtimePolicy === "Monthly Overtime" ? "This will recalculate the employee's whole month, to keep overtime correct."
                            : "This employee has no overtime policy set - only this duty will be recalculated.";
                        const btnLabel = payBillAlreadyCalculated ? "Recalculate Pay & Bill" : "Calculate Pay & Bill";
                        return (
                            <Popconfirm
                                title={btnLabel}
                                description={scopeHint}
                                onConfirm={handelPayBill}
                                okText="Proceed"
                                cancelText="Cancel"
                                disabled={calculatePayBillLoading || !payBillReady}
                                // nested inside the EditDutyModal's antd <Modal> - anchoring the
                                // popup to the trigger's own DOM subtree (instead of the antd
                                // default of document.body) keeps it from rendering behind the
                                // modal's own overlay
                                getPopupContainer={(triggerNode)=> triggerNode.parentElement || document.body}
                            >
                                <button
                                    disabled={calculatePayBillLoading || !payBillReady}
                                    className={(calculatePayBillLoading || !payBillReady) ? "drawer-outlined-btn disabled-btn" : "drawer-outlined-btn"}
                                    style={{marginRight:'15px'}}
                                    title={!payBillReady ? "Pay and bill start/end times must be set before calculating" : undefined}
                                >
                                    {calculatePayBillLoading? <Spinner/> : btnLabel}
                                </button>
                            </Popconfirm>
                        );
                    })()}
                    {changePayBill ?
                        <button className="drawer-outlined-btn" style={{marginLeft:'15px'}} onClick={updatePayBillOnChange}>Update pay bill</button>
                    : null}
                    <button disabled={(isCompleted || isUpdating)}  className={(isCompleted || isUpdating)? 'disabled-btn drawer-filled-btn':'drawer-filled-btn'}
                        onClick={handelScheduleOpertaionTime}
                    >
                        {isUpdating? <Spinner/> : "Save"}
                    </button>
                </div>

                                    

            </div>

            <CheckFailureModal visible={checkFailVisible} save={setOperationalAssignedEmployee} failureChecks={failureChecks} close={()=>setCheckFailVisible(!checkFailVisible)} />
            <WarningModal visible={warning} close={()=>setWarningModal(false)}/>

            {
                // cancelled duty object would be treated as boolean to open and close modal
                cancelledDuty && Object.keys(cancelledDuty)?.length>0?
                <CancelDutyModal
                    visible={true}
                    close={()=>setCancelledDuty({})}
                    cancelledDutyData={cancelledDuty}
                    // refetch={scheduleRefetch}
                    refetch={async ()=>{await scheduleJobRefetch()}}
                />
                : null
            }


        </div>
    );
};

const WarningModal = ({close, visible})=>{
    return(
        <Modal
            visible={visible}
            footer={null}
            closable={false}
        >

        <div className='modal-header-title'>
            <span style={{letterSpacing:'0.2px'}}> Warning </span>
            <span  onClick={close}><FontAwesomeIcon className='close' icon={faClose}/></span>
        </div>

            <div className='modal-body'>
                <Alert type="error" message={"Duty is not completed yet"} showIcon/>
            </div>

        </Modal>
    );
}